import { render, staticRenderFns } from "./CallReportIssues.vue?vue&type=template&id=d38ba2fe"
import script from "./CallReportIssues.vue?vue&type=script&lang=js"
export * from "./CallReportIssues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports